import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Note.module.scss';

export interface INoteProps extends HTMLAttributes<HTMLParagraphElement> {}

const Note: FC<INoteProps> = (props) => {
  const { className, children } = props;
  const rootClassName = classNames(styles.root, className);

  return <p className={rootClassName}>{children}</p>;
};

export default Note;
